import { FC, JSX, ReactNode } from 'react';
import styles from './Grid.scss';
import classNames from 'classnames';

type GridProps = {
  children: ReactNode;
  colGap?: boolean;
  col2?: boolean;
  sub?: boolean;
} & JSX.IntrinsicElements['div'];

export const Grid: FC<GridProps> = ({ children, className, colGap = false, col2 = false, sub = false }) => {
  return (
    <div
      className={classNames(styles.grid, colGap && styles.colGap, col2 && styles.col2, sub && styles.sub, className)}>
      {children}
    </div>
  );
};
